module.exports = __webpack_public_path__ + "static/media/u&g.cbeeab98.png";